//全局注册组件
import Header from '@/components/Header.vue';
//左侧一级导航
import LeftLevelNavigation from '@/components/LeftLevelNavigation.vue';
//方案管理-收藏
import collect from '@/components/programmeManagement/collect.vue';
//模型管理-重排目录
import dragmenu from '@/components/modelManagement/dragmenu.vue';
//模型管理-编辑数据
import editdata from '@/components/modelManagement/editdatas.vue';
//模型管理-确认
import validate from '@/components/modelManagement/validate.vue';
//模型管理-上传
import modelUpload from '@/components/modelManagement/modelUpload.vue';
//模型管理-模型参数
import ModelParameter from '@/components/modelManagement/modelParameter.vue';
//模型管理-添加标签
import AddLabel from '@/components/modelManagement/AddLabel.vue';
//模型管理-预览
import Preview from '@/components/modelManagement/Preview.vue';
//帮助管理-新增
import AddHelpRecord from '@/components/helpRecord/AddHelpRecord.vue';
const components = [
  { name: "Header", con: Header },
  { name: "LeftLevelNavigation", con: LeftLevelNavigation },
  { name: "collect", con: collect },
  { name: "dragmenu", con: dragmenu },
  { name: "editdata", con: editdata },
  { name: "validate", con: validate },
  { name: "modelUpload", con: modelUpload },
  { name: "ModelParameter", con: ModelParameter },
  { name: "AddLabel", con: AddLabel },
  { name: "Preview", con: Preview },
  { name: "AddHelpRecord", con: AddHelpRecord },
]
//循环注册组件
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component.con);
  });
};

export default {
  install
};
